<template>
  <el-row class="service-content" v-loading="isLoading">
    <el-col>
      <table class="service-layout">
        <colgroup>
          <col style="width: 70%;" />
          <col style="width: 30%;" />
        </colgroup>
        <tr>
          <td>
            <h5>{{dataIn.ServiceName}}</h5>
          </td>
          <td style="text-align: right;">
            <span>主负责人：</span>
            <span>{{!!dataIn.ResponsiblePersonId ? dataIn.ResponsiblePersonName : "未分配"}}</span>
          </td>
        </tr>
      </table>
    </el-col>
    <el-col>
      <el-table row-key="Id" :header-cell-style="{'background-color': 'rgb(227,227,227)'}" :row-style="{'background-color': 'whitesmoke'}"
        :cell-style="{'border-bottom': 0}" :show-summary="true" :summary-method="getTabelSummaries" :data="dataIn.ServiceItemList">
        <el-table-column prop="ServiceItemName" label="项目名称" min-width="160" />
        <el-table-column prop="SaleAmountDiscounted" label="真留价格" min-width="110"
          :formatter="(row, column, cellValue, index) => Object.toCurrency(cellValue, dataIn.WorkflowCurrency)" />
        <el-table-column prop="SaleAmountAvailable" label="剩余额度" min-width="110"
          :formatter="(row, column, cellValue, index) => Object.toCurrency(cellValue, dataIn.WorkflowCurrency)" />
        <el-table-column prop="EndDate" label="服务截止日期" min-width="120" :formatter="endDateFormatter" />
        <el-table-column prop="ResponsiblePersonName" label="跟进人员" min-width="120">
          <template #default="{row, $index}">
            <span>{{!!row.ResponsiblePersonId ? row.ResponsiblePersonName : "未分配"}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isReadonly" width="80">
          <template #default="{row, $index}">
            <el-button v-if="row.Status == GLOBAL.enumStudyAbroadStatus.NotStart || row.Status == GLOBAL.enumStudyAbroadStatus.InProgress" type="text" size="medium" @click="refund(row, $index)">退款</el-button>
            <span v-else :class="calcStatusClass(row)">{{GLOBAL.enumStudyAbroadStatus.getDesc(row.Status)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
import global_ from "@/core/global";
import { refundServiceItem } from "@/service/studyAbroad.service";

const mixin_generalMethods = {
  methods: {
    endDateFormatter(row, column, cellValue, index) {
      let mValue = this.$moment(cellValue);
      if (!mValue.isValid()) return null;

      return mValue.format("YYYY年M月D日");
    },
    getTabelSummaries({ columns, data }) {
      let sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "真留总额";
          return;
        }

        if (![1, 2].contains(index)) {
          sums[index] = String.empty;
          return;
        }

        let sumValue = data.sum((row) => row[column.property]);
        sums[index] = Object.toCurrency(sumValue, this.dataIn.WorkflowCurrency);
      });

      return sums;
    },
  },
};

const defaultWorkflowService = {
  ServiceName: null,
  WorkflowCurrency: global_.currencyType.CNY,
  ServiceItemList: [],
};

export default {
  name: "workflowServiceCard",
  mixins: [mixin_generalMethods],
  data(){
    return {
      isLoading : false,
    };
  },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      type: Object,
      default: () => Object.clone(defaultWorkflowService),
    },
  },
  methods: {
    calcStatusClass(data) {
      return {
        "color-status": true,
        "color-status-inProgress":
          data.Status === this.GLOBAL.enumStudyAbroadStatus.InProgress,
        "color-status-completed":
          data.Status === this.GLOBAL.enumStudyAbroadStatus.Completed,
        "color-status-closed":
          data.Status === this.GLOBAL.enumStudyAbroadStatus.Closed ||
          data.Status === this.GLOBAL.enumStudyAbroadStatus.Refund,
      };
    },
    refund(row, index) {
       this.$confirm(`您确认要退款该真留服务(${row.ServiceItemName})吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isLoading = true;
          refundServiceItem(row.Id).then(result =>{
            if (!!result && result.success){
              this.$message.success("退款成功");
              this.$emit("reload");
            }else{
              this.$message.error(result.message);
            }
            this.isLoading = false;
          })
          .catch(()=>{
            this.isLoading = false;
          });
        })
        .catch(() => {});
    }
  },
};
</script>

<style lang="scss" scoped>
.service-content {
  padding: 20px 0;

  .service-layout {
    width: 100%;

    h5 {
      margin-bottom: 0;
      line-height: inherit;
      font-weight: bold;
    }
  }
}

.el-table {
  /deep/ .el-table__footer td {
    background-color: rgb(227, 227, 227);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflowServiceCard.vue